// extracted by mini-css-extract-plugin
export default {"dim__container":"Dim_dim__container__cVTD0","dim__wrap":"Dim_dim__wrap__OcjIR"};